module.exports = __webpack_public_path__ + "media/dashboard/components/Accordion/icons/macros-313c342ac7a247634a95809dd0b617cd.svg";